/**
 * @fileoverview Town select and profile toggle for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import Select from "react-select";
import { logger } from "../../../utils/logger.js";
import { getLocationSelectStyles, getSafeSelectedOption } from "./locationSelectUtils";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressTownSelect = ({ model, t }) => {
  const {
    handleInputChange, handleToggleChange,
    isAddressReadOnly, secondAddressTownRef,
    secondAddressZipCodeRef, secondAddressNeighborhoodRef,
    secondAddressTowns, generalZipCodes,
    setSecondAddressZipCodes, generalNeighborhoods,
    setSecondAddressNeighborhoods, segundoDomicilioMunicipio,
    setSegundoDomicilioMunicipio, segundoDomicilioMostrarMunicipio,
    setSegundoDomicilioMostrarMunicipio,
  } = model;

  return (
    <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.location.townLabel")}
        </label>
        <Select
          ref={secondAddressTownRef}
          isSearchable={true}
          isDisabled={true}
          value={getSafeSelectedOption(
            secondAddressTowns,
            segundoDomicilioMunicipio,
          )}
          onChange={(selectedOption) => {
            logger.info("+++ Second Town selectedOption:", {
              data: selectedOption,
            });
            if (!selectedOption) {
              return;
            }

            setSegundoDomicilioMunicipio(selectedOption._id);
            handleInputChange("domicilio2Municipio", selectedOption._id);

            // Clear dependent fields
            secondAddressZipCodeRef.current.clearValue();
            secondAddressNeighborhoodRef.current.clearValue();

            // Filter neighborhoods and zip codes based on selected town
            const fileredNeighborhoods = generalNeighborhoods.filter(
              (neighborhood) =>
                neighborhood.idMunicipio == selectedOption._id,
            );
            logger.info("onChange Second Town fileredNeighborhoods:", {
              data: fileredNeighborhoods,
            });

            const filteredZipCodes = generalZipCodes.filter((zipcode) =>
              fileredNeighborhoods.some(
                (neighborhood) =>
                  neighborhood.idCodigoPostal == zipcode._id,
              ),
            );
            logger.info("onChange Second Town filteredZipCodes:", {
              data: filteredZipCodes,
            });

            setSecondAddressNeighborhoods(fileredNeighborhoods);
            setSecondAddressZipCodes(filteredZipCodes);

            logger.info("Second Town selectedOption:", {
              data: selectedOption,
            });
            setSegundoDomicilioMunicipio(selectedOption._id);
            handleInputChange("domicilio2Municipio", selectedOption._id);
          }}
          options={secondAddressTowns}
          placeholder={t("components.location.townPlaceholder")}
          styles={getLocationSelectStyles()}
          className="select__control"
          getOptionValue={(option) => option._id}
          formatOptionLabel={(option) => <span>{option.nombre}</span>}
        />
        <div className={styles.showInProfileContainer}>
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setSegundoDomicilioMostrarMunicipio(
                !segundoDomicilioMostrarMunicipio,
              );
              handleToggleChange(
                "domicilio2MostrarMunicipio",
                !segundoDomicilioMostrarMunicipio,
              );
            }}
            size="small"
            disabled={isAddressReadOnly}
            className={styles.toggleButton}
            sx={{
              "&.Mui-disabled": {
                cursor: CURSOR_NOT_ALLOWED,
                pointerEvents: "auto",
              },
              "& .MuiSvgIcon-root": {
                color: segundoDomicilioMostrarMunicipio
                  ? TOGGLE_COLOR_ACTIVE
                  : TOGGLE_COLOR_INACTIVE,
              },
            }}
          >
            {segundoDomicilioMostrarMunicipio ? (
              <ToggleOnIcon />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default SecondAddressTownSelect;
